import React, { useEffect, useState } from 'react';
import SensorCard from './SensorCard';
import LoadingComponent from '../loading/LoadingComponent';
import { useNavigate } from 'react-router-dom';
// import { SENSORS_LOADING_MESSAGE } from '../utils/Constants';

import { sensorsList, getCurrentReadings } from '../../services/sensors/sensorsService';

import { decodeToken } from '../utils/decodeToken/decodeToken';
import { useUser } from '../../context/UserContext';
import { homePath, canListSensors } from '../utils/homePath';
import ContractNotices from './ContractNotices';

const SensorsView = () => {
    const [sensors, setSensors] = useState([]);
    const [readingsBySensorId, setReadingsBySensorId] = useState({});
    const [isFetched, setIsFetched] = useState(false);
    const [isError, setIsError] = useState(false);
    const [showSensors, setShowSensors] = useState(false);

    const backgroundImage = "url('/assets/images/backgrounds/Sensors.jpg')";

    // const [currentSensorName, setCurrentSensorName] = useState('');
    const navigate = useNavigate();
    const { user, loading } = useUser();
    const canSeeCurrentReadings = !!(user && user.authorities && user.authorities.includes('GET_OWN_CROPS'));

    useEffect(() => {
        const fetchData = async () => {
            // Sin permiso para listar sensores (ej. vendedor), la consulta fallaría y cerraría la sesión
            if (loading) return;
            if (user && !canListSensors(user)) {
                navigate(homePath(user));
                return;
            }
            const token = decodeToken(localStorage.getItem('user-jwt'));        // token.sub es el correo, el email
            if (token && token.sub) {
                setTimeout(() => setShowSensors(true), 1500);
                try {
                    const response = await sensorsList();
                    setSensors(response);
                    setIsFetched(true);

                    if (canSeeCurrentReadings) {
                        try {
                            const currentReadings = await getCurrentReadings();
                            const readingsMap = {};
                            currentReadings.forEach(sensorReadings => {
                                readingsMap[sensorReadings.sensorId] = sensorReadings.readings;
                            });
                            setReadingsBySensorId(readingsMap);
                        } catch (readingsError) {
                            // Las lecturas actuales son un complemento; si fallan, la card
                            // sigue siendo usable sin ese bloque.
                            console.error('Error al obtener las lecturas actuales: ', readingsError);
                        }
                    }
                } catch (error) {
                    // La sesión vencida (401) la maneja el interceptor global; otro error no saca al usuario
                    console.error('Error al cargar los sensores: ', error);
                    setIsFetched(false);
                    setIsError(true);
                }
            } else {
                navigate('/error');
            }
        };
        fetchData();
    }, [navigate, canSeeCurrentReadings, loading, user]);

    // const loadingProps = {
    //     message: SENSORS_LOADING_MESSAGE,
    //     type: 'primary',
    // };

    if (isError) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4 p-4 text-center">
                <p className="text-gray-700">No se pudieron cargar tus sensores.</p>
                <button type="button" onClick={() => window.location.reload()}
                    className="rounded text-white bg-blue-600 hover:bg-blue-800 font-medium px-5 py-2.5 transition duration-200">
                    Intentar de nuevo
                </button>
            </div>
        );
    }

    if (isFetched && !isError && showSensors) {
        return (
            <div className="min-h-full flex flex-col">
                <div className="flex-1 min-h-screen bg-cover bg-center bg-fixed" style={{ backgroundImage: backgroundImage }}>
                    <ContractNotices />
                    <div className='p-4 flex flex-wrap items-start justify-center gap-4'>
                        {sensors.map((sensor) => (
                            <SensorCard key={sensor.id}
                                // setSensorNameFunction={setCurrentSensorName}
                                handleShow={null} // asumiendo que 'handleShow' se pasa como prop si es necesario
                                values={sensor}
                                currentReadings={readingsBySensorId[sensor.id]}
                                onAccessLost={(id) => setSensors((current) => current.filter((s) => s.id !== id))}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div>
                <LoadingComponent />
                {/* <LoadingComponent data={loadingProps} /> */}
            </div>
        );
    }
};

export default SensorsView;